import { createFileRoute, redirect } from "@tanstack/react-router";
import { WarehouseClient, type WarehouseTab } from "@/features/billing/WarehouseClient";
import { firstAllowedRoute, hasModule } from "@/lib/auth";

// Commercie → Warehouse (docs/tms-facturatie-warehouse.md §5): reading is billing; typing the quantities in, setting a
// week ready and offering a change to a price list billing_write; approving it price_agreements_approve (W2).
export const Route = createFileRoute("/_shell/billing/warehouse")({
  beforeLoad: ({ context }) => {
    const { session } = context;
    if (!session.roles.includes("admin") && !hasModule(session, "billing") && !hasModule(session, "billing_write") && !hasModule(session, "price_agreements_approve")) {
      throw redirect({ to: firstAllowedRoute(session) });
    }
  },
  validateSearch: (search: Record<string, unknown>): { tab?: WarehouseTab } => ({
    tab: search.tab === "agreements" ? "agreements" : undefined,
  }),
  component: WarehouseScreen,
});

function WarehouseScreen() {
  const { session } = Route.useRouteContext();
  const { tab } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <div className="wl-page wl-page--list" data-screen-label="Back-office Warehouse-facturatie">
      <WarehouseClient
        tab={tab ?? "weeks"}
        userId={session.userId}
        canWrite={session.roles.includes("admin") || hasModule(session, "billing_write")}
        canApprove={session.roles.includes("admin") || hasModule(session, "price_agreements_approve")}
        onTab={(next) => navigate({ search: (s) => ({ ...s, tab: next === "weeks" ? undefined : next }) })}
      />
    </div>
  );
}
